import React from 'react';

const SendVoice = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#ocbsk5z7ja)' fill='#000'>
        <path d='M19.826 12.848a.716.716 0 0 0-1.431 0c0 3.5-2.848 6.349-6.349 6.349a6.356 6.356 0 0 1-6.349-6.35.716.716 0 0 0-1.431 0c0 4.05 3.108 7.385 7.064 7.748v1.927H8.674a.716.716 0 1 0 0 1.431h6.744a.716.716 0 0 0 0-1.431h-2.656v-1.927c3.956-.362 7.064-3.698 7.064-7.747z' />
        <path d='M12.046 17.43a4.588 4.588 0 0 0 4.583-4.582V4.536a4.588 4.588 0 0 0-4.583-4.583 4.588 4.588 0 0 0-4.583 4.583v8.312a4.588 4.588 0 0 0 4.583 4.583zM8.894 4.537a3.155 3.155 0 0 1 3.152-3.151 3.155 3.155 0 0 1 3.151 3.15v8.313a3.155 3.155 0 0 1-3.151 3.151 3.155 3.155 0 0 1-3.152-3.151V4.536z' />
      </g>
      <defs>
        <clipPath id='ocbsk5z7ja'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SendVoice;
